

function AboutMe(){

    return(
        <div  className="relative w-11/12 md:w-4/5 xl:w-3/5 h-auto md:h-full mx-auto pt-2 p-6 bg-white mt-12  duration-150 ease-in-out
        hover:bg-gray-50 hover:border-2 hover:border-red-400 rounded-2xl ">
            <h1 className="font-bold text-red-400 text-2xl 2xl:text-4xl  mx-auto w-full text-center">About Me</h1>
            <p className="mt-2 text-lg 2xl:text-2xl font-gilroy-light p-2">I'm a FullStack Web Developer located in metro Detroit
            who is obsessed with finding simple solutions to complex problems. I recently completed Springboard's Software Engineering
            boot camp and will be graduating with an Associates in computer programming in December.
             </p>
             <p className="text-lg font-gilroy-light mt-2 2xl:text-2xl p-2">I'm a highly motivated person, a passionate coder and problem solver.
             Fan of outdoor activities including mountain biking and fishing and have an eagerness to learn any and all web technologies
             I can get my hands on. </p>
        </div>
    )
    

}

export default AboutMe